import(/* webpackMode: "eager", webpackExports: ["ServicePage"] */ "/vercel/path0/src/app/(pages)/(services)/proactive-ip/service.tsx");
